import { render, staticRenderFns } from "./WhatsappV1.vue?vue&type=template&id=40426fbc"
import script from "./WhatsappV1.vue?vue&type=script&lang=js"
export * from "./WhatsappV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports